import React from "react";

import { ImageLazy, Link, LinkProps } from "@catchoftheday/cg-components";
import { css } from "@catchoftheday/theme";

type LinkImageProps = {
  height: string;
  width: string;
  src: string;
  alt: string;
  href: string;
  linkCss?: ReturnType<typeof css>;
  imageCss?: ReturnType<typeof css>;
} & LinkProps;

export const LinkImage = ({
  height,
  width,
  src,
  alt,
  href,
  imageCss,
  ...LinkProps
}: LinkImageProps) => {
  return (
    <Link href={href} {...LinkProps}>
      <ImageLazy
        alt={alt}
        src={src}
        width={width}
        height={height}
        css={css`
          ${imageCss || ""}
        `}
      />
    </Link>
  );
};
